import { Icd9Code } from '@dreryk/egabinet-icd-dictionary-published-language-api';
import { MedicalImagingCreateCommand } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { convertLocalDateTimeToDate } from '@dreryk/react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { patientMedicalInformationTranslationKeys } from '../../translations';
import { refetchAllMedicalInformation } from '../shared/refetchAllMedicalInformation';

import { MedicalImagingEntryFormBean, MedicalImagingEntryFormController } from './MedicalImagingEntryForm.types';

type MedicalImagingCreateActionProps = Pick<MedicalImagingEntryFormController, 'handleSubmit'> & {
   readonly medicalInformationId: number;
   readonly onSuccess: (parameters: MedicalImagingEntryFormBean) => void;
};

export const MedicalImagingCreateAction = (props: MedicalImagingCreateActionProps): JSX.Element => {
   const { executeAsync: createMedicalImaging } = useCqrsCommand<void, MedicalImagingEntryFormBean>(
      (parameters) => {
         const command = new MedicalImagingCreateCommand();
         command.confidentialityLevel = parameters.confidentialityLevel;
         command.description = Choice.of(parameters.description);
         command.examinationDate = convertLocalDateTimeToDate(
            parameters.examinationDate.atTime(parameters.examinationTime)
         );
         command.icd9Code = Icd9Code.of(parameters.icd9Procedure.code);
         command.medicalInformationId = props.medicalInformationId;

         return command;
      },
      {
         onSuccess: (__, parameters) => {
            dispatchSnackbarPositiveEvent(patientMedicalInformationTranslationKeys.successfullyAddedNewEntry);
            refetchAllMedicalInformation();
            props.onSuccess(parameters);
         },
      }
   );

   return (
      <ModalConfirmButton
         testId={'createMedicalImaging'}
         label={patientMedicalInformationTranslationKeys.medicalImaging.addEntry}
         onClick={props.handleSubmit(createMedicalImaging)}
      />
   );
};
